export class LocalStorage {

    static get(key: LocalStorageType) {
        const value = localStorage.getItem(key) || sessionStorage.getItem(key);
        try {
            return JSON.parse(value as any);

        } catch (error) {
            return localStorage.getItem(key);

        }
    }

    static set(key: LocalStorageType, value: any, storageForSingleTab?: boolean) {
        if (storageForSingleTab) {
            sessionStorage.setItem(key, JSON.stringify(value))

        } else {
            localStorage.setItem(key, JSON.stringify(value))

        }
    }

    static clear(key?: LocalStorageType) {
        if (key) {
            localStorage.removeItem(key);
            sessionStorage.removeItem(key);
        } else {
            localStorage.clear();
            sessionStorage.clear();

        }
    }
}

type LocalStorageType = 'lang' |
    'auth' |
    'isDarkMode' |
    'idpSettings' |
    'OnBehalfUserId' |
    'LanguagePrefrences' |
    'IsUserSessionInitialize' |
    'SessionCode' |
    'designOptions' |
    'actionBarLocation' |
    'url' |
    'userInfo' |
    'assignmentUserId' |
    'sidebarStatus' |
    'CorrespondencesInboxFilter' |
    'userMarkingImage' |
    'userSignatureImage' |
    'calendar' |
    'tabId' |
    'isMobile' |
    'correspondenceNavigationData' |
    'backHistory' | 
    'demo' | 
    'sidebarOptionBCorrespondenceModulePushes' |
    'backupBackHistory';
